import { render, staticRenderFns } from "./grafik.vue?vue&type=template&id=2461e35c&"
import script from "./grafik.vue?vue&type=script&lang=js&"
export * from "./grafik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports